import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=42eb582c&scoped=true&"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=js&"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyProgram.vue?vue&type=style&index=0&id=42eb582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eb582c",
  null
  
)

export default component.exports